import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import useAxios
 from '../../axios/useAxios';

const ButtonProduct = ({ title, scanProductInfo, setCode }) => {
  return (
    <button type="button"
            className="rounded-full py-1 px-4 border-[2px] bg-slate-300 text-2xl"
            onClick={() => setCode(scanProductInfo)}>
      {title}
    </button>
  )
}

const DemoProduct = ({ setCode }) => {
  const fakeProductInfo = {
    "symbology": "ean13",
    "data": "XXXXXXXXXXXXX"
  }

  const axiosInstance = useAxios();
  const { store } = useSelector((state) => state.store);

  const [showProducts, setShowProducts] = useState(false);
  const [productMinInfo, setProductMinInfo] = useState();
  const [productMediumInfo, setProductMediumInfo] = useState();
  const [productHighInfo, setProductHighInfo] = useState();

  const retrieveDemoProduct = async () => {
    if (!store?.id) return;

    try {
      const currentProducts = await axiosInstance.get(
        `/products/price-ranges/${store?.id}`
      );

      const { lowPriceProduct, mediumPriceProduct, highPriceProduct } = currentProducts.data
      const symbology = { symbology: "ean13" }

      if (lowPriceProduct) setProductMinInfo({ ...symbology, data: lowPriceProduct.Code_Barre })
      if (mediumPriceProduct) setProductMediumInfo({ ...symbology, data: mediumPriceProduct.Code_Barre })
      if (highPriceProduct) setProductHighInfo({ ...symbology, data: highPriceProduct.Code_Barre })
    } catch (error) {
      console.error('retrieveDemoProduct error', error);
    }
    finally {
      setShowProducts(true)
    }
  };

  useEffect(() => {
    retrieveDemoProduct()
  }, [store]);

  return (
    <div className="absolute z-[1000] top-52 w-full">
    {showProducts ?
      <div className="flex justify-between items-center mx-5">
      {productMinInfo &&
        <ButtonProduct title="Product 1" scanProductInfo={productMinInfo} setCode={setCode} />}
      {productMediumInfo &&
        <ButtonProduct title="Product 2" scanProductInfo={productMediumInfo} setCode={setCode} />}
      {productHighInfo &&
        <ButtonProduct title="Product 3" scanProductInfo={productHighInfo} setCode={setCode} />}

        <ButtonProduct title="Fake Product" scanProductInfo={fakeProductInfo} setCode={setCode} />
      </div> : null}
    </div>
  );
};

export default DemoProduct;
